import { defineStore } from 'pinia'
import { getStandardUnits, getDimensionalUnits } from '@/utils/units'

const CACHE_TIME = 30 * 60 * 1000

export const useUnitsStore = defineStore('units', {
  state: () => ({
    standardUnits: [],
    dimensionalUnits: [],
    lastFetch: 0
  }),

  persist: true,

  actions: {
    async loadUnits(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < CACHE_TIME

      // Cache fresh hai aur data hai toh skip
      if (!force && isFresh && this.standardUnits.length && this.dimensionalUnits.length) {
        return {
          standard: this.standardUnits,
          dimensional: this.dimensionalUnits
        }
      }

      try {
        const [standard, dimensional] = await Promise.all([
          getStandardUnits(),
          getDimensionalUnits()
        ])
        this.standardUnits = standard
        this.dimensionalUnits = dimensional
        this.lastFetch = now
      } catch (error) {
        console.log(error.message)
      }

      return {
        standard: this.standardUnits,
        dimensional: this.dimensionalUnits
      }
    },

    clearCache() {
      this.standardUnits = []
      this.dimensionalUnits = []
      this.lastFetch = 0
    }
  }
})